export default __webpack_public_path__ + "static/media/section1-bg7.50c28012.png";